export default __webpack_public_path__ + "static/media/rai-wei.1e3f97ee.svg";